// export const SERVER_URL = 'http://localhost/projects/repairing_shop_apis/api/';
// export const SERVER_URL = 'https://test3.godlyfaces.com/api/';
export const SERVER_URL = 'https://kobutorapis.godlyfaces.com/api/';
// export const SERVER_URL = 'http://kobutorapis.godlyfaces.com/api/';
